import React, { ReactElement } from 'react';
import './stars.scss';

export interface StarsProps {
    className?: string;
    width: number;
}

const Stars: React.FC<StarsProps> = ({ className, width }): ReactElement => (
    <div className={`star-rating ${className || ''}`}>
        <span style={{ width: `${width * 20}%` }}/>
    </div>
);

export default Stars;
